// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__1ZjiA","loginCard":"Login_loginCard__hIqIu","header":"Login_header__X6076","logo":"Login_logo__UGlwR","body":"Login_body__2gpqV"};